import { render, staticRenderFns } from "./BackgroundItem.vue?vue&type=template&id=c99741c4&scoped=true&"
import script from "./BackgroundItem.vue?vue&type=script&lang=js&"
export * from "./BackgroundItem.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundItem.vue?vue&type=style&index=0&id=c99741c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99741c4",
  null
  
)

export default component.exports